export enum Env {
  DEV = 'dev',
  STAGING = 'staging',
  PROD = 'prod'
}
